var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.ORDER_ABNORMAL_FIVE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          radio: _vm.radio,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          afterFetchOriginalData: _vm.getTableData,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channel", "storeIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.No"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("InternalOrder.No") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("InternalOrder.order") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: { placeholder: _vm.$t("InternalOrder.order") },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "cusId",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.webReference)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.webReference,
                                            },
                                          }),
                                        ]
                                      : col.prop === "sapOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.sapOrderNo)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.sapOrderNo,
                                            },
                                          }),
                                        ]
                                      : col.prop === "tagsList"
                                      ? [
                                          _c("BjTagList", {
                                            attrs: {
                                              "tag-code-array":
                                                scope.row[col.prop],
                                              size: "mini",
                                              circle: "",
                                            },
                                          }),
                                        ]
                                      : col.prop === "failureReason"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.LANG_ZH_EN_PS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "orderTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOperateTwoHour")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "shippingMethod"
                                      ? [
                                          [
                                            "CUSTOMER MANUAL",
                                            "CSG MANUAL",
                                            "PICKUP",
                                          ].includes(scope.row[col.prop])
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "success" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row[col.prop])
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[col.prop])
                                                ),
                                              ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: {
                                          disabled: props.row.isMark,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onMark(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("markText")))]
                                    ),
                                    props.row.hjShipmentTime
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onCancel(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("cancelText")))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }